/**
 * Handles API errors array from response
 * If there's 1 error - shows specific backend message
 * If there are multiple errors - shows generic message about partial data unavailability
 *
 * @param errors - Array of error messages from API response
 * @param dispatch - Redux dispatch function
 * @param setError - Redux action creator for setting error
 */
export const handleApiErrors = (
  errors: string[] | undefined,
  dispatch: any,
  setError: (payload: { title?: string; translateId?: string }) => any,
): void => {
  if (!errors || errors.length === 0) {
    return;
  }

  if (errors.length === 1) {
    // Show specific error from backend
    dispatch(setError({ title: errors[0] }));
  } else {
    // Show generic error message when multiple errors
    dispatch(setError({ translateId: 'error.partialDataUnavailable' }));
  }
};
